import { render, staticRenderFns } from "./OverallSalesDetailApp.vue?vue&type=template&id=3b2cb66a&scoped=true"
import script from "./OverallSalesDetailApp.vue?vue&type=script&lang=js"
export * from "./OverallSalesDetailApp.vue?vue&type=script&lang=js"
import style0 from "./OverallSalesDetailApp.vue?vue&type=style&index=0&id=3b2cb66a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2cb66a",
  null
  
)

export default component.exports